export const destinationColumns = [
    {
      Header: 'District',
      accessor: 'district',
    },
    {
      Header: 'District Code',
      accessor: 'districtCode',
    },
    {
      Header: 'Destination',
      accessor: 'destination',
    },
    {
      Header: 'Category',
      accessor: 'category',
    },
    {
      Header: 'Attraction Point',
      accessor: 'attractionPoint',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
  }
    
  ];

